// «Найти и заменить» в расшифровке: целые слова, без учёта регистра.
//
// \b в JS кириллицу словом не считает, поэтому граница слова — «не буква/цифра»
// через \p{L}\p{N} с флагом u. Без lookbehind: регулярка собирается при вызове,
// но та же конструкция литералом уже роняла сборку на iOS Safari < 16.4
// (docs/backlog/front-ios-safari-lookbehind.md) — левую границу ловим группой.

const escapeRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

function wordRe(find) {
  // Пробелы фразы — без перевода строки: иначе «ерпэ петров» склеит конец реплики
  // с меткой следующего участника и сотрёт её.
  const phrase = escapeRe(find.trim()).replace(/\s+/g, '[^\\S\\n]+');
  return new RegExp(`(^|[^\\p{L}\\p{N}_])(${phrase})(?=[^\\p{L}\\p{N}_]|$)`, 'giu');
}

/** Сколько раз фраза встречается целыми словами. */
export function countWords(text, find) {
  if (!text || !find || !find.trim()) return 0;
  return (text.match(wordRe(find)) || []).length;
}

/** Заменить все вхождения фразы целыми словами. → { text, count } */
export function replaceWords(text, find, replacement) {
  if (!text || !find || !find.trim()) return { text: text || '', count: 0 };
  let count = 0;
  const next = text.replace(wordRe(find), (_, left) => {
    count += 1;
    return left + replacement;
  });
  return { text: next, count };
}
